import { useEffect } from 'react';
// import { useTranslation } from 'react-i18next';
import { useAnalytics } from '../../hooks/useAnalytics';
// import { Button } from '../../../@/ui/button';
// import { Card } from '../../../@/ui/card';

interface CookieConsentProps {
  onAccept?: () => void;
  onDecline?: () => void;
}

export const CookieConsent: React.FC<CookieConsentProps> = ({ onAccept }) => {
  // const { t } = useTranslation();
  const { grantConsent, hasConsent } = useAnalytics();
  // const [isVisible, setIsVisible] = useState(false);
  // const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    // Auto accept cookies if user hasn't made a choice yet
    if (!hasConsent()) {
      // Auto grant consent since privacy policy already mentions cookie usage
      // and users can change this in privacy settings if needed
      grantConsent();
      onAccept?.();
    }
  }, [hasConsent, grantConsent, onAccept]);

  // const handleAccept = () => {
  //   setIsAnimating(false);
  //   setTimeout(() => {
  //     setIsVisible(false);
  //     grantConsent();
  //     onAccept?.();
  //   }, 300);
  // };

  // const handleDecline = () => {
  //   setIsAnimating(false);
  //   setTimeout(() => {
  //     setIsVisible(false);
  //     revokeConsent();
  //     onDecline?.();
  //   }, 300);
  // };

  // Since we auto-accept cookies, no need to show the consent banner
  return null;

  // Original consent banner code (kept for reference but not used)
  /*
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center p-4 pointer-events-none">
      <Card
        className={`
          max-w-md w-full p-6 pointer-events-auto
          bg-white/95 dark:bg-gray-900/95 backdrop-blur-sm
          border border-gray-200 dark:border-gray-700
          shadow-lg transition-all duration-300 ease-out
          ${isAnimating ? 'translate-y-0 opacity-100' : 'translate-y-full opacity-0'}
        `}
      >
        <div className="space-y-4">
          <div className="space-y-2">
            <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
              {t('privacy.cookieConsent.title', 'Cookie Consent')}
            </h3>
            <p className="text-sm text-gray-600 dark:text-gray-300 leading-relaxed">
              {t(
                'privacy.cookieConsent.description',
                'We use cookies and analytics to improve your experience and understand how you use our service. Your privacy is important to us.',
              )}
            </p>
          </div>

          <div className="flex flex-col sm:flex-row gap-3">
            <Button
              onClick={handleAccept}
              className="flex-1 bg-blue-600 hover:bg-blue-700 text-white"
              size="sm"
            >
              {t('privacy.cookieConsent.accept', 'Accept')}
            </Button>
            <Button
              onClick={handleDecline}
              variant="outline"
              className="flex-1 border-gray-300 dark:border-gray-600"
              size="sm"
            >
              {t('privacy.cookieConsent.decline', 'Decline')}
            </Button>
          </div>

          <p className="text-xs text-gray-500 dark:text-gray-400">
            {t(
              'privacy.cookieConsent.learnMore',
              'You can change your preferences anytime in settings.',
            )}
          </p>
        </div>
      </Card>
    </div>
  );
  */
};

export default CookieConsent;
